import React, { useEffect, useState, useRef, useMemo, useCallback } from "react";
import "./Dashboard.scss";
import { FaBell, FaUserCircle, FaCog, FaBars, FaTimes, FaChalkboard, FaClock } from "react-icons/fa";
import { useLocation, useNavigate, Outlet } from "react-router-dom";
import { GetCurrentUser } from "../../components/GetCurrentUser";
import Cookies from "js-cookie";
import gsap from "gsap";

import casesimg from "../../assets/images/casesnotactive.svg";
import tasksimg from "../../assets/images/tasksnotactive.svg";
import myclientsimg from "../../assets/images/clientnotactive.svg";
import invoicesimg from "../../assets/images/invoicesnotactive.svg";
import expensesimg from "../../assets/images/expensenotactive.svg";
import timelineimg from "../../assets/images/timelinenotactive.svg";
import actsimg from "../../assets/images/actsnotactive.svg";
import labelsimg from "../../assets/images/labelsnotactive.svg";
import notesimg from "../../assets/images/notesnotactive.svg";
import casesimgactive from "../../assets/images/casesactive.svg";
import tasksimgactive from "../../assets/images/tasksactive.svg";
import myclientsimgactive from "../../assets/images/clientactive.svg";
import invoicesimgactive from "../../assets/images/invoicesactive.svg";
import expensesimgactive from "../../assets/images/expenseactive.svg";
import timelineimgactive from "../../assets/images/timelineactive.svg";
import actsimgactive from "../../assets/images/actsactive.svg";
import labelsimgactive from "../../assets/images/labelsactive.svg";
import notesimgactive from "../../assets/images/notesactive.svg";
import { DetailSection } from "../../components/DetailSection/DetailSection.js";
import { useAuth } from "../../context/AuthContext.js";
import { LuListTree } from "react-icons/lu";
import { IoPersonAddSharp } from "react-icons/io5";
import { GrUserAdmin } from "react-icons/gr";
import { Notifications } from "../../components/Notifications/Notifications.js";
import { getNotification } from "../../services/api/NotificationsApi.js";
import { BackButton } from "../../components/BackButton.js";
import { useBubbleSettings } from "../../context/BubbleSettingsContext.js";
import lawsuitprologo from '../../assets/images/dark-main-pro.jpeg';
import kingplan from '../../assets/images/king-plan.png';
import PlanSelectionModal from '../../components/PlanSelectionModal/PlanSelectionModal';

const allTabItems = [
    {
    name: "SuperAdmin",
    icon: <GrUserAdmin size={18} color="#686868" />,
    activeicon: <GrUserAdmin size={18} color="#004A9A" />,
    route: "/home/superadmin",
    permission: "superAdmin"
  },
  // {
  //   name: "Display Board",
  //   icon: <FaChalkboard size={18} color="#686868" />,
  //   activeicon: <FaChalkboard size={18} color="#004A9A" />,
  //   route: "/home/displayboard",
  //   permission: "displayboard"
  // },

];

export const Dashboard = () => {

  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeTab, setActiveTab] = useState("");
  const notificationRef = useRef(null);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showSettingsMenu, setShowSettingsMenu] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const sidebarRef = useRef(null);
  const settingsRef = useRef(null);
  const { company, role, visibility, logout, user, accessToken } = useAuth();
  const { bubbleSettings, setBubbleSettings } = useBubbleSettings();
  const userMenuRef = useRef(null);

  const [showNotifications, setShowNotifications] = useState(false);
  const toggleNotifications = () => setShowNotifications((prev) => !prev);
  const isEnt = company?.type === 'ent';

  const [notificationCount, setNotificationCount] = useState(0);
  const [trialDaysLeft, setTrialDaysLeft] = useState(null);
  const [showTrialWarning, setShowTrialWarning] = useState(false);
  const [subscriptionDaysLeft, setSubscriptionDaysLeft] = useState(null);
  const [isPlanModalOpen, setIsPlanModalOpen] = useState(false);
  const hasInitialized = useRef(false);


  // Function to calculate trial days remaining
  const calculateTrialDaysLeft = useCallback(() => {
    if (!company?.subscription) return null;

    const { paymentStatus, currentPeriodEnd } = company.subscription;

    // Check if it's a free trial - handle different formats
    const isFreeTrial = paymentStatus === 'Free Trial' ||
      paymentStatus === 'trial' ||
      paymentStatus === 'free_trial' ||
      paymentStatus?.toLowerCase().includes('trial');

    if (isFreeTrial && currentPeriodEnd) {
      const endDate = new Date(currentPeriodEnd);
      const currentDate = new Date();
      const timeDiff = endDate.getTime() - currentDate.getTime();
      const daysLeft = Math.ceil(timeDiff / (1000 * 3600 * 24));

      return Math.max(0, daysLeft); // Ensure we don't return negative days
    }

    return null;
  }, [company?.subscription]);

  // Function to calculate subscription days remaining for paid plans
  const calculateSubscriptionDaysLeft = useCallback(() => {
    if (!company?.subscription) return null;

    const { paymentStatus, currentPeriodEnd } = company.subscription;

    const isFreeTrial = paymentStatus === 'Free Trial' ||
      paymentStatus === 'trial' ||
      paymentStatus === 'free_trial' ||
      paymentStatus?.toLowerCase().includes('trial');

    if (!isFreeTrial && currentPeriodEnd) {
      const endDate = new Date(currentPeriodEnd);
      const currentDate = new Date();
      const timeDiff = endDate.getTime() - currentDate.getTime();
      const daysLeft = Math.ceil(timeDiff / (1000 * 3600 * 24));

      return Math.max(0, daysLeft); // Ensure we don't return negative days
    }

    return null;
  }, [company?.subscription]);



  const navigate = useNavigate();
  const location = useLocation();
  const currentuser = GetCurrentUser();
  const isCaseDetails = location.pathname.startsWith("/home/cases/casedetails");
  const iseditLabel = location.pathname.startsWith("/home/labels/editlabel/");
  const iseditExpense = location.pathname.startsWith("/home/expenses/edit/");
  const iseditBranch = location.pathname.startsWith("/home/branch/edit/");
  const isviewBranch = location.pathname.startsWith("/home/branch/view/");
  const isAddTask = location.pathname === "/home/tasks/newtask";
  const isEditTask = location.pathname.startsWith("/home/tasks/edit/");
  const isViewTask = location.pathname.startsWith("/home/tasks/viewtask/");
  const isUserDetailPage = location.pathname.startsWith("/home/addusers/");
  const isNewNote = location.pathname === "/home/notes/newnote";
  const isEditNote = location.pathname.startsWith("/home/notes/edit-note/");
  const isViewNote = location.pathname.startsWith("/home/notes/details/");
  const isEditClient = location.pathname.startsWith("/home/my-clients/edit/");
  const isViewLabel = location.pathname.startsWith("/home/labels/");
  const isnewLabel = location.pathname === "/home/labels/newlabel";
  const isnewExpense = location.pathname === "/home/expenses/newexpense";
  const isViewExpense = location.pathname.startsWith("/home/expenses/viewexpense/");
  const isViewMyClient = location.pathname.startsWith("/home/my-clients/viewmyclient/");
  const isNewCase = location.pathname === "/home/cases/newcase";
  const isProfile = location.pathname === "/home/profile";
  const isGlobalSettings = location.pathname === "/home/settings";
  const isTimeline = location.pathname.startsWith("/home/timeline");
  const isDisplayCalendarExtended = location.pathname === "/home/displayboard/extended-view"
  const isTasks = location.pathname === "/home/tasks";
  const isAddSAPlan = location.pathname === "/home/superadmin/addplan";
  const isEditSAPlan = location.pathname.startsWith("/home/superadmin/editplan/");
  const isAddSACompany = location.pathname === "/home/superadmin/addcompany";
  const isAddSAUser = location.pathname === "/home/superadmin/adduser";
  const isEditSACompany = location.pathname.startsWith("/home/superadmin/editcompany/");
  const isEditCourtForms = location.pathname.startsWith("/home/cases/editcase/");
  const isEditSAUser = location.pathname.startsWith("/home/superadmin/edituser/");
  const isAddEditSuperAdminCompanyCourtDetails = location.pathname.startsWith("/home/superadmin/court-details/");
  const isCreateSystemInvoice = location.pathname.startsWith("/home/superadmin/create-system-invoice/");

  const isSuperAdmin = location.pathname === "/home/superadmin";
  const isInvoice = location.pathname === "/home/invoices";
  const isAddInvoice = location.pathname === "/home/invoices/add";


  const isDisplayBoard = location.pathname === "/home/displayboard";
  const isAddMyClient = location.pathname === "/home/my-clients/add-client";
  const isAddBranch = location.pathname === "/home/branch/add";
  const isViewSAPlan = location.pathname.startsWith("/home/superadmin/plandetails/");
  const isViewCompanyDetails = location.pathname.startsWith("/home/superadmin/companydetails/");


  const userRights = company?.rights;
  const userVisibility = visibility;
  console.log(company, "companyiii");
  console.log(userRights, "userRights");
  console.log(userVisibility, "userVisibility");
  console.log(bubbleSettings, "bubbleSettings");
  const unseenCount = bubbleSettings?.unSeenNotifications || 0;

  console.log(role, "role");
  console.log(bubbleSettings,"bubbleSettingsbubbleSettings")
  const enhancedTabItems = allTabItems.map((tab) => {
    if (tab.name === 'Cases') {
      return { ...tab, count: bubbleSettings?.caseCount ||  0 };
      // return { ...tab, count: bubbleSettings?.caseCount + bubbleSettings?.assignmentCount ||  0 };
    }
    if (tab.name === 'Tasks') {
      return { ...tab, count: bubbleSettings?.taskCount || 0 };
    }
    return tab;
  });
  const tabItems = useMemo(() => {
    // Add safety checks
    if (!company || !userVisibility || !enhancedTabItems) {
      return [];
    }

    if (role === 'customer') {
      return enhancedTabItems?.filter(tab =>
        tab.name === 'Cases' || tab.name === 'Invoices'
      );
    }

    return enhancedTabItems?.filter(tab => {
      if (tab.name === 'Display Board') return true;

      // const hasPermission = userVisibility[tab.permission];
      // return hasPermission === true;

    const hasPermissionKey = tab.permission in userVisibility;
    const isPermissionTrue = userVisibility[tab.permission] === true;
    
    return hasPermissionKey && isPermissionTrue;
    });
  }, [role, userVisibility, company, enhancedTabItems]);




  console.log("Filtered tabItems:", tabItems);

  // useEffect(() => {
  //   if (
  //     tabItems.length > 0 &&
  //     !activeTab &&
  //     location.pathname !== "/home/settings"
  //   ) {
  //     setActiveTab(tabItems[0].name);
  //   }
  // }, [tabItems, activeTab, location.pathname]);

useEffect(() => {
  if (hasInitialized.current) return;
  
  if (
    tabItems.length > 0 &&
    !activeTab &&
    location.pathname !== "/home/settings"
  ) {
    hasInitialized.current = true;
    setActiveTab(tabItems[0].name);
  }
}, [tabItems.length, activeTab, location.pathname]);
  
  useEffect(() => {
    // Only proceed if we have company data to avoid multiple triggers
    if (!company?.subscription) return;

    const daysLeft = calculateTrialDaysLeft();
    setTrialDaysLeft(daysLeft);

    const subscriptionDays = calculateSubscriptionDaysLeft();
    setSubscriptionDaysLeft(subscriptionDays);

    console.log("Trial calculation:", {
      paymentStatus: company?.subscription?.paymentStatus,
      currentPeriodEnd: company?.subscription?.currentPeriodEnd,
      trialDaysLeft: daysLeft,
      subscriptionDaysLeft: subscriptionDays
    });
  }, [company?.subscription, calculateTrialDaysLeft, calculateSubscriptionDaysLeft]);



  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (mobile) {
        setSidebarOpen(false);
        gsap.set(sidebarRef.current, { width: "0px" });
      } else {
        setSidebarOpen(true);
        gsap.set(sidebarRef.current, { width: "250px" });
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const currentPath = location.pathname;

    if (currentPath === "/home/settings") {
      setActiveTab("");
      return;
    }

    const matchingTab = tabItems.find((tab) => tab.route === currentPath);

    if (matchingTab) {
      setActiveTab(matchingTab.name);
    } else if (currentPath === "/home" && tabItems.length > 0) {
      setActiveTab(tabItems[0].name);
      navigate(tabItems[0].route, { replace: true });
    }
  }, [location, navigate, isMobile, tabItems]);


  const toggleSidebar = () => {
    const newState = !sidebarOpen;
    setSidebarOpen(newState);

    gsap.to(sidebarRef.current, {
      width: newState ? (isMobile ? "250px" : "250px") : (isMobile ? "0px" : "60px"),
      duration: 0.3,
      ease: "power2.inOut",
    });
  };

  const handleLogout = () => {
    logout();
    // Delay navigation to allow state updates to complete
    setTimeout(() => {
      navigate("/");
    }, 0);
  };

  const handleSelectPlan = (selectedPlan, companyId, paymentData) => {
    console.log('Selected Plan:', selectedPlan);
    console.log('Company ID:', companyId);
    console.log('Payment Data:', paymentData);
    // Payment is handled in PlanSelectionModal
    // This callback is called after successful payment
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab.name);
    navigate(tab.route);
  };

  const toggleSettingsMenu = () => {
    {
      role !== 'customer' &&
        navigate('/home/settings');
    }
  };

  const toggleUserMenu = () => {
    setShowUserMenu(!showUserMenu);
    if (!showUserMenu && userMenuRef.current) {
      gsap.fromTo(userMenuRef.current, { opacity: 0, y: -10 }, { opacity: 1, y: 0, duration: 0.15 });
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        settingsRef.current && !settingsRef.current.contains(event.target)
      ) {
        setShowSettingsMenu(false);
      }
      if (
        userMenuRef.current && !userMenuRef.current.contains(event.target)
      ) {
        setShowUserMenu(false);
      }
      if (
        notificationRef.current && !notificationRef.current.contains(event.target)
      ) {
        setShowNotifications(false);
      }
    };

    if (showSettingsMenu || showUserMenu || showNotifications) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showSettingsMenu, showUserMenu, showNotifications]);

  useEffect(() => {
    const fetchNotificationCount = async () => {
      try {
        const res = await getNotification();
        const unSeenNotificationsCount = res?.data?.unSeenNotifications || 0; // Adjust based on actual API response
        setNotificationCount(unSeenNotificationsCount);
      } catch (error) {
        console.error("Error fetching notification count:", error);
      }
    };

    fetchNotificationCount();
  }, []);
  // Add this after all your hooks but before your other logic:
  if (!user || !accessToken) {
    return null;
  }

  return (
    <div className="dashboard-container">
      {isMobile && sidebarOpen && (
        <div
          className="mobile-sidebar-overlay"
          onClick={toggleSidebar}
        />
      )}
      <div
        className={`dashboard-sidebar ${sidebarOpen ? 'open' : 'closed'}`}
        ref={sidebarRef}
      >
        <div className={`sidebar-header${!sidebarOpen ? ' sidebar-header-closehead' : ''}`}>
          {/* <h3 className={`lawsuitheadtxt ${!sidebarOpen ? "dashboard-hidden-title" : ""}`}>
            Lawsuit Pro
          </h3> */}
          <img src={lawsuitprologo} alt="lawsuitprologo" className={`lawsuitheadtxt ${!sidebarOpen ? "dashboard-hidden-title" : ""}`} />
          {isMobile && (
            <button className="close-sidebar-btn" onClick={toggleSidebar}>
              <FaTimes />
            </button>
          )}
        </div>
        {tabItems.map((tab) => (
          <div
            key={tab.name}
            className={`dashboard-sidebar-tab ${activeTab === tab.name ? "active" : ""}`}
            onClick={() => handleTabClick(tab)}
          >
            <div className="dashboard-tab-icon" title={tab.name}>
              {React.isValidElement(tab.icon)
                ? (activeTab === tab.name ? tab.activeicon : tab.icon)
                : (
                  <img
                    src={activeTab === tab.name ? tab.activeicon : tab.icon}
                    alt={tab.name}
                  />
                )}
            </div>

            {(sidebarOpen || !isMobile) && (
              <span className="tab-label-with-badge">
                {tab.name}
                {typeof tab.count === "number" && tab.count > 0 && (
                  <span className="count-badge">{tab.count}</span>
                )}
              </span>
            )}
          </div>
        ))}

        {/* {company?.type && role !== 'customer' && sidebarOpen && (
          <div className={`sidebar-plan-section ${isEnt ? 'ent-mode' : ''} ${(company?.subscription?.paymentStatus === 'Free Trial' ||
              company?.subscription?.paymentStatus?.toLowerCase().includes('trial')) ? 'trial-mode' : ''
            }`}>
            <div className="plan-content">
              <div className="plan-badge">
                <span className="plan-icon">
                  <img
                    src={kingplan}
                    alt="EntIcon"
                    className="icon-image"
                    width="16"
                    height="16"
                  />
                </span>
                <span className="plan-label">
                  {(company?.subscription?.paymentStatus === 'Free Trial' ||
                    company?.subscription?.paymentStatus?.toLowerCase().includes('trial')) ? 'Free Trial' :
                    company.type === 'ent'
                      ? 'Enterprise'
                      : company.type === 'std'
                        ? 'Standard'
                        : company.type === 'prm'
                          ? 'Premium'
                          : company.type === 'ind'
                            ? 'Individual'
                            : company.type
                  }
                </span>
              </div>

              {(company?.subscription?.paymentStatus === 'Free Trial' ||
                company?.subscription?.paymentStatus?.toLowerCase().includes('trial')) &&
                trialDaysLeft !== null && (
                  <div className="trial-countdown">
                    <div className="trial-icon">
                      <FaClock size={14} color="#ff6b35" />
                    </div>
                    <div className="trial-info">
                      <span className="trial-text">Trial ends in</span>
                      <span className={`trial-days ${trialDaysLeft <= 3 ? 'urgent' : ''}`}>
                        {trialDaysLeft} {trialDaysLeft === 1 ? 'day' : 'days'}
                      </span>
                    </div>
                  </div>
                )}

              {!(company?.subscription?.paymentStatus === 'Free Trial' || 
                company?.subscription?.paymentStatus?.toLowerCase().includes('trial')) && 
                subscriptionDaysLeft !== null && 
                subscriptionDaysLeft <= 7 && (
                <div className="trial-countdown subscription-countdown">
                  <div className="trial-icon">
                    <FaClock size={14} color="#4f46e5" />
                  </div>
                  <div className="trial-info">
                    <span className="trial-text">Subscription ends in</span>
                    <span className={`trial-days ${subscriptionDaysLeft <= 7 ? 'urgent' : ''}`}>
                      {subscriptionDaysLeft} {subscriptionDaysLeft === 1 ? 'day' : 'days'}
                    </span>
                  </div>
                </div>
              )}

              {(!isEnt ||
                (company?.subscription?.paymentStatus === 'Free Trial' ||
                  company?.subscription?.paymentStatus?.toLowerCase().includes('trial'))) && (
                  <button
                    className="upgrade-button"
                    onClick={() => {
                      if (company?._id) {
                        setIsPlanModalOpen(true);
                      } else {
                        console.error("Company ID not found");
                      }
                    }}
                  >
                    {(company?.subscription?.paymentStatus === 'Free Trial' ||
                      company?.subscription?.paymentStatus?.toLowerCase().includes('trial'))
                      ? 'Upgrade to Continue' : 'Upgrade Now'}
                  </button>
                )}
            </div>
          </div>
        )} */}
      </div>

      <div className="dashboard-main-area">
        <div className="dashboard-top-navbar">
          <div className="dashboard-top-nav-icons1">
            <button className="hamburger" onClick={toggleSidebar}>
              {/* {sidebarOpen && !isMobile ? <FaBars size={18} /> : <FaBars size={25}/>} */}
              <FaBars size={isMobile ? 18 : 23} />
            </button>
            {!isDisplayBoard && <BackButton />}
            <h4 className="dashboard-activetabname">
              {location.pathname === "/home/cases/casedetails"
                ? "Cases / CaseDetails"
                : location.pathname === "/home/settings"
                  ? "Settings"
                  : activeTab}
            </h4>
          </div>
          <div className="dashboard-top-nav-icons">
            {(role === 'admin' || role === 'moderator') && <div className="dashboard-micon relative" ref={settingsRef}>
              <FaCog
                className="dashboard-top-nav-icon-style"
                onClick={toggleSettingsMenu}
                title="Settings"
                size={isMobile ? 18 : 23}
                color="#686868"
              />
            </div>}
            {/* <div className="dashboard-notifyuser dashboard-micon" onClick={toggleNotifications} style={{ position: "relative" }} ref={notificationRef}>
              <FaBell
                className="dashboard-top-nav-icon-style"
                title="Notifications"
                size={isMobile ? 18 : 23}
                color="#686868"
              />

              {unseenCount > 0 && (
                <span className="notification-badge">
                  {unseenCount}
                </span>
              )}

              <Notifications show={showNotifications} />
            </div> */}

            <div className="dashboard-notifyuser dashboard-micon" ref={userMenuRef}>
              <FaUserCircle
                className="dashboard-top-nav-icon-style"
                title="User"
                onClick={toggleUserMenu}
                size={isMobile ? 18 : 23}
                color="#686868"
              />
              {showUserMenu && (
                <div className="dashboard-userstyles">
                  <button className="dashboard-profiletabs" onClick={() => navigate("/home/profile")}>Profile</button>
                  {/* <button className="dashboard-profiletabs">Settings</button> */}
                  <button className="dashboard-profiletabs" onClick={handleLogout}>Logout</button>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="dashboard-content-area">
          {!location.pathname.startsWith("/home/cases/casedetails") &&
            location.pathname !== "/home/settings" &&
            location.pathname !== "/home/tasks/newtask" &&
            !location.pathname.startsWith("/home/tasks/edit/") &&
            !location.pathname.startsWith("/home/addusers/") &&
            !location.pathname.startsWith("/home/labels/editlabel/") &&
            !location.pathname.startsWith("/home/expenses/edit/") &&
            !location.pathname.startsWith("/home/branch/edit/") &&
            !location.pathname.startsWith("/home/branch/view/") &&
            !location.pathname.startsWith("/home/notes/edit-note/") &&
            !location.pathname.startsWith("/home/my-clients/edit/") &&
            !location.pathname.startsWith("/home/tasks/viewtask/") &&
            !location.pathname.startsWith("/home/expenses/viewexpense/") &&
            !location.pathname.startsWith("/home/my-clients/viewmyclient/") &&
            location.pathname !== "/home/labels/newlabel" &&
            location.pathname !== "/home/profile" &&
            location.pathname !== "/home/expenses/newexpense" &&
            location.pathname !== "/home/displayboard/extended-view" &&
            location.pathname !== "/home/cases/newcase" &&
            location.pathname !== "/home/notes/newnote" &&
            location.pathname !== "/home/addusers/add-user" &&
            location.pathname !== "/home/branch/add" &&
            location.pathname !== "/home/timeline" &&
            location.pathname !== "/home/superadmin" &&
            location.pathname !== "/home/superadmin/adduser" &&
            location.pathname !== "/home/superadmin/addcompany" &&
            location.pathname !== "/home/my-clients/add-client" &&
            location.pathname !== "/home/invoices/add" &&
            location.pathname !== "/home/displayboard" &&
            !isViewNote && !isEditCourtForms && !isViewLabel && !isAddBranch && !isAddSAPlan && !isEditSAPlan && !isEditSAUser && !isEditSACompany
            && !isAddEditSuperAdminCompanyCourtDetails && !isViewSAPlan && !isViewCompanyDetails && !isCreateSystemInvoice &&
            !(location.pathname === "/home/invoices" && role === 'customer') &&
            (
              <div className="main-dashboard-content-area">
                <DetailSection username={currentuser} activeTab={activeTab} />
              </div>
            )}

          <div className={isCaseDetails || isTimeline || isDisplayBoard || iseditLabel || isnewLabel || iseditExpense || iseditBranch || isviewBranch
            || isDisplayCalendarExtended || isUserDetailPage || isProfile || isGlobalSettings || isEditNote || isEditTask || isAddTask
            || isNewCase || isEditClient || isnewExpense || isViewTask || isViewExpense || isViewMyClient || isViewNote || isNewNote || (isInvoice && role === 'customer')
            || isAddMyClient || isViewLabel || isAddBranch || isAddInvoice || isEditSAPlan || isAddSAPlan || isEditSACompany || isAddSACompany || isEditCourtForms
            || isEditSAUser || isAddSAUser || isAddEditSuperAdminCompanyCourtDetails || isViewSAPlan || isViewCompanyDetails || isCreateSystemInvoice || isSuperAdmin ? "page-content-tabsone page-content-tabs" : "page-content-tabs"}>
            <div className={isCaseDetails || isTasks || isDisplayBoard ? "page-content-component page-content-componentone" : "page-content-component"}>
              <Outlet />
            </div>
          </div>
        </div>
      </div>

      <PlanSelectionModal
        isOpen={isPlanModalOpen}
        companyId={company?._id}
        onClose={() => setIsPlanModalOpen(false)}
        onSelectPlan={handleSelectPlan}
      />
    </div >
  );
};